import React from 'react';
import Modal from 'modules/views/shared/Modal';
import MultiSelect from 'modules/views/shared/MultiSelect';
import { useStyles } from '../styles';
import { useTranslation } from 'react-i18next';

interface DeclineProjectModalProps {
  isVisible: boolean;
  selectedProject: any;
  selectedCompanies: { label: string; value: string }[];
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCompanyChange: (companyIds: string[]) => void;
}

const DeclineProjectModal: React.FC<DeclineProjectModalProps> = ({
  isVisible,
  selectedProject,
  selectedCompanies,
  isLoading,
  onClose,
  onConfirm,
  onCompanyChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal
      isVisible={isVisible}
      title={t('projectList.declineProject', { value: selectedProject?.project?.name })}
      testId="decline-project-modal"
      onClose={onClose}
      modalContentStyleClass={classes.modalContentNoPadding}
      Content={
        <div className={classes.modalContent}>
          <MultiSelect
            placeholder={t('projectList.selectCompanies')}
            testId="decline-project-companies-select"
            required={true}
            options={
              selectedProject?.companies?.map(company => ({
                value: company?.company?.id || '',
                label: company?.company?.name || '',
              })) || []
            }
            selectedValues={selectedCompanies}
            onChange={values => {
              onCompanyChange(values);
            }}
          />
        </div>
      }
      actionButtons={[
        {
          label: t('common.cancel'),
          variant: 'outlined',
          testId: 'decline-project-cancel-button',
          onClick: onClose,
        },
        {
          label: t('common.confirm'),
          variant: 'contained',
          testId: 'decline-project-confirm-button',
          onClick: onConfirm,
          disabled: selectedCompanies.length === 0 || isLoading,
        },
      ]}
    />
  );
};

export default DeclineProjectModal;
